const i18nService = async (language) => {
  const url = `./translations/${language}.json`;
  const response = await fetch(url);
  const data = await response.json();
  return data;
};

export { i18nService };